import { OrderedSet } from 'immutable'

import { getEntityMap } from 'data'
import userPreferencesRecord from './record'

export const getUserPreferences = state => {
  const map = getEntityMap(state, 'UserPreferences')
  return map.first() || new userPreferencesRecord()
}

export const isChannelFavorite = (state, channelId) => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return false
  }
  return userPreferences.get('favoriteChannelIds').has(channelId)
}
export const getFavoriteChannelIds = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return new OrderedSet()
  }
  return userPreferences.get('favoriteChannelIds')
}

export const isChannelMuted = (state, channelId) => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return false
  }
  return userPreferences.get('mutedChannelIds').has(channelId)
}
export const getMutedChannelIds = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return new OrderedSet()
  }
  return userPreferences.get('mutedChannelIds')
}

export const getChannelFavoriteIds = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return new OrderedSet()
  }
  return userPreferences.get('favoriteChannelIds')
}

export const hasSeenNearNoteLimitIncentiveAt = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return new OrderedSet()
  }
  return Boolean(userPreferences.get('seenNearNoteLimitIncentiveAt'))
}

export const isDesktopUser = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return null
  }
  return userPreferences.get('isDesktopUser')
}

export const isNoteBookmarked = (state, noteId) => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return false
  }
  return userPreferences.get('bookmarkedNoteIds').has(noteId)
}

export const isInviteOnboardingStep = state => {
  const userPreferences = getUserPreferences(state)
  const onboardingStep = userPreferences.get('onboardingStep')
  if (!userPreferences) {
    return false
  }
  return onboardingStep === 'invite'
}

export const isChannelOnboardingDone = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return false
  }
  return userPreferences.get('isChannelOnboardingDone')
}

export const getBookmarkedNoteIds = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return new OrderedSet()
  }
  return userPreferences.get('bookmarkedNoteIds')
}

export const getLastVisitedNoteIds = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return OrderedSet()
  }
  return userPreferences.get('lastVisitedNoteIds')
}

export const getLastVisitedChannelIds = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return OrderedSet()
  }
  return userPreferences.get('lastVisitedChannelIds')
}

export const getLastSearchedTerms = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return OrderedSet()
  }
  return userPreferences.get('lastSearchedTerms')
}

export const getFeatureFlags = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return false
  }
  return userPreferences.get('featureFlags')
}

export const hasFeatureFlag = (state, flag) => {
  return getFeatureFlags(state)
    .split(/[,\s]+/)
    .includes(flag)
}

export const closedImportContentCallToActionAt = state => {
  const userPreferences = getUserPreferences(state)

  if (!userPreferences) {
    return false
  }
  return userPreferences.get('closedImportContentCallToActionAt')
}

export const COLORMODES = {
  DARK: 'dark',
  LIGHT: 'light',
  SYSTEM: 'system',
}
export const getColorMode = state => {
  const userPreferences = getUserPreferences(state)
  if (!userPreferences) {
    return false
  }
  return userPreferences.get('colorMode')
}
